<fikoyt-kart>
      <button nz-button
              nz-wave
              style="position: absolute;"
              [routerLink]="['/']"
              nzType="default"
              nzShape="circle"
              nzSize="small"><nz-icon nzType="home" /></button>
      <img ngSrc="./simgeler/fikoyt_yazi.png"
           alt="Site Logo Yazı"
           height="54"
           width="166"
           style="height: unset; width: 166px; box-shadow: none !important;align-self: center;">
      <nz-alert nzMessage="Hoş Geldiniz"
                style="text-align: center;"></nz-alert>

      <form>
            <span nz-typography
                  nzType="secondary">Kullanıcı Adı :</span>
            <nz-input-wrapper nzPrefix="👨"
                            nzSize="small">
                  <input type="text" autocomplete="username"  nz-input placeholder="Kullanıcı Adı"  [(ngModel)]="form.kullaniciAdi"  [ngModelOptions]="{standalone: true}" (keydown.enter)="this.FikoYT.kimlik.girisYap(this.form)"/>
            </nz-input-wrapper>

            <span nz-typography
                  nzType="secondary">Parola :</span>
            <nz-input-wrapper nzPrefix="🔑"
                            nzSize="small">
                  <input type="password"  autocomplete="current-password" nz-input placeholder="Parola"  [(ngModel)]="form.parola"  [ngModelOptions]="{standalone: true}" (keydown.enter)="this.FikoYT.kimlik.girisYap(this.form)"/>
            </nz-input-wrapper>
      </form>
      <button nz-button
              nzSize="small"
              nzType="link"
              style="margin-top: 0.5em;"
              nz-wave
              (click)="this.FikoYT.kimlik.girisYap(this.form);">
            🗝️
            Giriş Yap
      </button>
      <nz-divider></nz-divider>
      <div style="flex-direction: row;display: flex;">
            <a nz-button
               nz-wave
               routerLink="/sifre-sifirla"
               nzType="link">🔓 Şifre Sıfırla</a>
            <span style="flex: 1;"></span>
            <a nz-button
               nz-wave
               routerLink="/kayit"
               nzType="link">🙌 Aramıza Katıl</a>
      </div>
</fikoyt-kart>